// Iter 141 — media URL helpers for seasonal themes / hero banners.

// YouTube or Vimeo page URL → embeddable autoplay-muted-loop iframe URL.
// Returns null for anything else (assume direct video file).
export function videoEmbedUrl(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?.*v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) {
    return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&mute=1&loop=1&playlist=${yt[1]}&controls=0&rel=0&playsinline=1&modestbranding=1&enablejsapi=1`;
  }
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) {
    return `https://player.vimeo.com/video/${vm[1]}?autoplay=1&muted=1&loop=1&background=1`;
  }
  return null;
}

export function looksLikeImageUrl(url) {
  if (!url) return true;
  return /\.(jpe?g|png|webp|gif|avif|svg)(\?|#|$)/i.test(url) ||
         /(unsplash\.com|pexels\.com|images\.|img\.|cdn\.)/i.test(url);
}

// Theme visibility status for the admin list.
export function themeStatus(t) {
  if (!t.enabled) return { key: 'off', label: 'Off' };
  const today = new Date().toISOString().slice(0, 10);
  if (t.start_date && t.start_date > today) return { key: 'scheduled', label: `Scheduled (from ${t.start_date})` };
  if (t.end_date && t.end_date < today) return { key: 'expired', label: `Expired (${t.end_date})` };
  return { key: 'live', label: 'Live now' };
}
